import React from 'react'
import { Box } from '@material-ui/core'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import {
  PhishingDashboardCards,
  PhishingDashboardChart,
  RecentCampaignsTable,
} from './components'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'
import * as service from 'service'
import { routes } from 'Routes'

const PhishingDashboard = () => {
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(3)

  const { response: indicatorsResponse, isLoading: isLoadingIndicators } =
    useFetch(service.dponet.phishingIndicators.show, { groupBy: 'month' })

  const { response: campaignsResponse, isLoading: isLoadingCampaigns } =
    useFetch(service.dponet.phishingCampaigns.dashboard, { perPage, page }, [
      page,
      perPage,
    ])

  const indicators = indicatorsResponse?.data
  const campaigns = campaignsResponse?.data?.phishingCampaigns ?? []
  const campaignsCount = campaignsResponse?.data?.meta?.totalCount ?? 0

  const isLoading = isLoadingIndicators || isLoadingCampaigns

  return (
    <Page title="Indicadores de Phishing">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="Indicadores de Phishing" />
        <PhishingDashboardCards
          indicators={indicators}
          onNewCampaign={() => service.history.push(routes.phishing.new)}
        />
        <Box mt={3}>
          <PhishingDashboardChart indicators={indicators} />
        </Box>
        <Box mt={3}>
          <RecentCampaignsTable
            campaigns={campaigns}
            isLoading={isLoadingCampaigns}
            count={campaignsCount}
            pagination={{
              perPage,
              page,
              handleChangePage,
              handleChangeRowsPerPage,
            }}
          />
        </Box>
      </Container>
    </Page>
  )
}

export default PhishingDashboard
